"use client";
import { sendGTMEvent } from "@next/third-parties/google";
import { AnalyticsCategories } from "@/constants/analytics";
import { NextWebVitalsMetric } from "next/app";

export function sendToAnalytics({
  id,
  name,
  label,
  value,
}: NextWebVitalsMetric): void {
  sendGTMEvent({
    category:
      label === "web-vital"
        ? AnalyticsCategories.webVitals
        : AnalyticsCategories.nextJS,
    action: name,
    value: Math.round(name === "CLS" ? value * 1000 : value), // values must be integers
    label: id, // id unique to current page load
    nonInteraction: true, // avoids affecting bounce rate
  });
}
